/* Scroll-snap pas activeren na de eerste echte gebruikersinteractie.
   mandatory-snap-carousels her-snappen anders tijdens de load bij elke
   layoutverandering (fonts/afbeeldingen laden in); Chrome telt die snap als
   scroll en stopt daarna DEFINITIEF de LCP-meting — vandaar NO_LCP/een
   uitroepteken in PageSpeed op mobiel. De bijbehorende CSS-override
   (html:not(.sophior-snap-ready) -> scroll-snap-type: none) staat in
   sophior-brand.css. Bewust NIET achter de reduced-motion-guard hieronder:
   dit is geen animatie. Bij de allereerste pointer/touch/wheel/key-input
   staat snap alweer aan, dus de swipe-ervaring verandert niet. */
(() => {
  const enableSnap = () => document.documentElement.classList.add('sophior-snap-ready');
  ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach((ev) =>
    window.addEventListener(ev, enableSnap, { once: true, passive: true, capture: true })
  );
})();

/* Scroll-reveal: elementen met .sophior-reveal faden 16px omhoog zodra ze
   in beeld komen (stijlen in sophior-brand.css). Alleen below-the-fold
   elementen krijgen de init-staat, zodat er boven de vouw nooit een flits
   ontstaat; bij reduced-motion of zonder IntersectionObserver doet dit
   script niets en blijft alles direct zichtbaar. */
(() => {
  if (!('IntersectionObserver' in window)) return;
  if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) return;

  const STAGGER_MS = 60;
  const els = Array.from(document.querySelectorAll('.sophior-reveal')).filter(
    (el) => el.getBoundingClientRect().top > window.innerHeight * 0.9
  );
  if (!els.length) return;

  const reveal = (el) => {
    el.classList.add('sophior-reveal--in');
    el.classList.remove('sophior-reveal--init');
  };

  let observerFired = false;

  const io = new IntersectionObserver(
    (entries) => {
      observerFired = true;
      let batch = 0;
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.style.transitionDelay = `${batch * STAGGER_MS}ms`;
        batch += 1;
        reveal(entry.target);
        io.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -10% 0px' }
  );

  for (const el of els) {
    el.classList.add('sophior-reveal--init');
    io.observe(el);
  }

  /* Failure-safety: mocht de IntersectionObserver nooit vuren (render- of
     layout-glitch), dan blijven de op --init gezette elementen anders permanent
     onzichtbaar. Alleen in dát geval (observer heeft na 4s nog geen enkele
     callback gehad) maken we alles zichtbaar en stoppen we de observer; werkt
     de observer wel, dan blijft de scroll-reveal gewoon actief. De verborgen
     --init-staat wordt sowieso pas door dit script gezet, dus zonder JS blijft
     alles direct zichtbaar. */
  window.setTimeout(() => {
    if (observerFired) return;
    io.disconnect();
    for (const el of els) {
      if (el.classList.contains('sophior-reveal--init')) reveal(el);
    }
  }, 4000);
})();
